<template>
    <div>

        <el-container>
            <el-header height="auto"><common-header /></el-header>
            <el-container>
                <el-aside class="no-top" width="auto">
                    <common-asideVue />
                </el-aside>
                <el-main class="el-main">
                    <traingaiqiantuipiao-right />
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import CommonAsideVue from '@/components/CommonAside.vue'
    import CommonHeader from '@/components/CommonHeader.vue'
    import TraingaiqiantuipiaoRight from "../components/TraingaiqiantuipiaoRight";
    export default {
        components: {
            TraingaiqiantuipiaoRight,
            ElContainer,CommonHeader,CommonAsideVue},
        name: "traingaiqiantuipiao",
        data () {
            return {}
        },
        methods: {

        }
    }
</script>

<style scoped>
    .el-header{
        padding:0;
    }
    .no-top /deep/ .el-menu{
        margin-top: 0;
    }
</style>